<template>
  <Loader v-if="loading" />
  <div ref="fileTableContainer" :style="{ minHeight: fileTableHeight ? `${fileTableHeight}px` : undefined }">
  <DataTable :value="filteredItems" :sortOrder="-1" sortField="data_creazione" :rowClass="data => data.data_eliminazione ? 'file-eliminato' : ''" stripedRows rowHover paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" breakpoint="1190px">
    <template #header>
        <div class="flex flex-wrap align-items-center justify-content-between gap-2">
          <div role="group" aria-label="Filtra per codice servizio" class="flex flex-column gap-2">
            <span>Filtra per codice servizio</span>
            <div class="flex flex-wrap align-items-center gap-2">
            <Button label="Tutti" :class="{ 'm-1 p-button-outlined': selectedService !== null }" :aria-pressed="selectedService === null" style="font-size: 14px;" @click="selectService(null)" />
            <Button v-for="code in serviceOptions" :key="code" :label="code" :class="{ 'm-1 p-button-outlined': selectedService !== code }" :aria-pressed="selectedService === code" style="font-size: 14px;" @click="selectService(code)" />
            </div>
          </div>

          <Button icon="pi pi-refresh" class="m-2" style="font-size: 14px;" @click="getActivePratiche()"/>
        </div>
      </template>

    <template #empty>
      <div class="text-center">Nessun dato</div>
    </template>
    <Column field="filename" header="File di richiesta" />
    <Column field="provider" header="Provider">
      <template #body="{data}">{{ data.provider ? data.provider.toUpperCase() : '--' }}</template>
    </Column>
    <Column field="total" header="Numero righe">
      <template #body="{data}">
        <p v-tooltip="data.total > 0 ? data.codes : null">{{ data.total }}</p>
      </template>
    </Column>
    <Column field='data_creazione' header="Data Creazione" :sortable="true">
      <template #body="{data}">
        {{moment(data.data_creazione).format('DD-MM-YYYY HH:mm')}}
      </template>
    </Column>
    <Column field="ID richiesta" header="ID richiesta">
      <template #body="{data}">
        <InputMask v-if="data.id_richiesta == null && !data.data_eliminazione" v-model="id_pratica[data.filename]" mask="9999999" style="max-width: 5rem;"/>
        <p v-else> {{ data.id_richiesta || '--' }} </p>
      </template>

    </Column>
    <Column field='processed' header="Completo">
      <template #body="{data}">
        <span v-if="data.data_eliminazione" v-tooltip.top="`Eliminato il ${moment(data.data_eliminazione).format('DD-MM-YYYY HH:mm')}`"><strong>Eliminato</strong></span>
        <span v-else-if="data.processed">
          <i class="pi pi-check text-green-400" style="font-size: 1rem"></i>
        </span>
        <span v-else>
          <i class="pi pi-ban p-error" style="font-size: 1rem"></i>
        </span>
      </template>
    </Column>
    <Column field='data_elaborazione' header="Data Elaborazione" :sortable="true">
      <template #body="{data}">
        {{data.data_elaborazione ? moment(data.data_elaborazione).format('DD-MM-YYYY HH:mm') : '--'}}
      </template>
    </Column>
    <Column :exportable="false" header="Visualizza file">
      <template #body="{data}">
        <div class="file-row-buttons">
          <Button v-tooltip.top="'Dettaglio richiesta'" aria-label="Dettaglio richiesta" icon="pi pi-file" class="p-button-info" :disabled="!!data.data_eliminazione" @click="showFileDetails(data, 'request')" />
          <Button v-if="data.processed == true" v-tooltip.top="'Dettaglio risposta'" aria-label="Dettaglio risposta" icon="pi pi-eye" class="p-button-info" @click="showFileDetails(data, 'response')" />
        </div>
      </template>
    </Column>


    <Column :exportable="false" header="Azioni">
      <template #body="{data}">
        <div class="file-row-buttons">
          <Button v-if="!data.data_eliminazione && !data.id_richiesta && (id_pratica[data.filename] != null && id_pratica[data.filename] != '')" v-tooltip.top="'Salva ID richiesta'" aria-label="Salva ID richiesta" icon="pi pi-link" :disabled="id_pratica[data.filename] == ''" @click="saveIdPratica(data.filename, id_pratica[data.filename], data.filename)" />
          <Button v-if="!data.data_eliminazione && !data.processed && (isManualPractice(data) || data.id_richiesta)" v-tooltip.top="'Gestione ammissibilità'" aria-label="Gestione ammissibilità" icon="pi pi-cog" @click="openAmmissibilita($event, data)" />
          <span v-if="!data.data_eliminazione && !data.processed" v-tooltip.top="data.storico_disponibile ? 'Elimina' : 'Applicare lo schema dello storico prima di eliminare'">
            <Button aria-label="Elimina" icon="pi pi-trash" class="p-button-danger" :disabled="!!data.data_eliminazione || !data.storico_disponibile" @click="showFileDetails(data, 'delete')" />
          </span>
          <Button v-if="data.numero_eliminazioni > 0" v-tooltip.top="'Storico eliminazioni'" aria-label="Storico eliminazioni" icon="pi pi-list" class="p-button-secondary" @click="showFileDetails(data, 'history')" />
        </div>
      </template>
    </Column>
  </DataTable>
  </div>
  <OverlayPanel ref="ammissibilitaOverlay" :showCloseIcon="true" :style="{ width: '20rem', maxWidth: 'calc(100vw - 2rem)' }">
    <div v-if="ammissibilitaFile" class="ammissibilita-actions">
      <strong>Gestione ammissibilità</strong>
      <span class="ammissibilita-filename">{{ ammissibilitaFile.filename }}</span>
      <Button v-if="isManualPractice(ammissibilitaFile) && !ammissibilitaFile.processed" label="Manuale" icon="pi pi-pencil" @click="openManualFromOverlay" />
      <span v-tooltip.top="massiveUploadHint(ammissibilitaFile)" class="block">
        <FileUpload mode="basic" :auto="true" accept=".csv" customUpload :disabled="!canUploadMassive(ammissibilitaFile)" @uploader="uploadMassiveFromOverlay" chooseLabel="Massiva" />
      </span>
    </div>
  </OverlayPanel>
  <ConsultazioneFilePratica
    v-if="detailVisible"
    v-model:visible="detailVisible"
    :filename="detailFilename"
    :width="detailType === 'history' ? '65rem' : '90vw'"
    :title="detailType === 'history' ? 'Storico eliminazioni' : detailType === 'delete' ? 'Elimina righe dalla richiesta' : detailType === 'request' ? 'Dettaglio richiesta' : 'Dettaglio risposta'"
    :load-data="loadDetailData"
    :download="detailType === 'request' ? downloadFilePratica : null"
    :delete-rows="detailType === 'delete' ? deleteRequestRows : null"
    @deleted="getActivePratiche"
  />
  <Dialog v-model:visible="manualVisible" modal header="Gestisci ammissibilità manuale" :style="{ width: '90vw', height: '80vh' }" :contentStyle="{ flex: '1 1 auto', minHeight: '0', overflowY: 'auto' }" :closable="!manualBusy" :closeOnEscape="!manualBusy" @hide="manualKoOverlay?.hide()">
    <p>{{ manualFilename }}</p>
    <div class="flex flex-wrap align-items-center gap-2 mb-3">
      <InputText v-model="manualSearch" placeholder="Cerca POD/PDR" aria-label="Cerca POD/PDR" @update:modelValue="manualFirst = 0" />
      <Button label="Reset ricerca" icon="pi pi-times" class="p-button-outlined" style="border: 1px solid currentColor; margin-right: 0.5rem;" :disabled="!manualSearch" @click="manualSearch = ''; manualFirst = 0" />
      <Button label="Esita tutti in OK" class="p-button-success" style="border: 1px solid #437520; margin-right: 0.5rem;" :disabled="manualBusy || !manualRows.length" @click="setAllManualOutcomes(1)" />
      <Button label="Esita tutti in KO" class="p-button-danger" style="border: 1px solid #a51f2b; margin-right: 0.5rem;" :disabled="manualBusy || !manualRows.length" @click="manualKoOverlay.toggle($event)" />
      <small>Le azioni si applicano a tutte le {{ manualRows.length }} rig{{manualRows.length === 1 ? 'a' : 'he'}} del file, anche se filtrate.</small>
    </div>
    <OverlayPanel ref="manualKoOverlay" :showCloseIcon="true" :style="{ width: '28rem', maxWidth: 'calc(100vw - 2rem)' }">
      <p>Questa motivazione verrà assegnata a tutte le righe del file, che saranno salvate con esito KO, sostituendo eventuali esiti e motivazioni già presenti.</p>
      <label for="manual-bulk-reason">Motivazione KO comune</label>
      <Textarea id="manual-bulk-reason" v-model="manualBulkReason" rows="4" maxlength="2000" class="w-full mt-2" :disabled="manualBusy" />
      <Button label="Applica KO a tutti" class="p-button-danger mt-2" style="border: 1px solid #a51f2b;" :disabled="manualBusy || !manualBulkReason.trim()" @click="setAllManualOutcomes(2, manualBulkReason)" />
    </OverlayPanel>
    <DataTable v-model:first="manualFirst" :value="filteredManualRows" :loading="manualLoading" paginator :rows="10" responsiveLayout="scroll">
      <template #empty>Nessuna fornitura trovata.</template>
      <Column field="code" header="POD / PDR" />
      <Column field="protocollo" header="Protocollo">
        <template #body="{ data }">{{ data.protocollo ?? '—' }}</template>
      </Column>
      <Column field="denominazione_cliente" header="Cliente" />
      <Column header="Esito">
        <template #body="{ data }">
          <SelectButton v-model="data.esito" :options="manualOptions" optionLabel="label" optionValue="value" class="manual-outcomes" :disabled="manualBusy" @update:modelValue="changeManualOutcome(data)" />
        </template>
      </Column>
      <Column header="Motivazione KO">
        <template #body="{ data }">
          <div v-if="data.esito === 2">
            <div class="manual-ko-editor">
              <Textarea v-model="data.motivazione" rows="1" maxlength="2000" :disabled="manualBusy" placeholder="Motivazione ricevuta dal distributore" />
              <Button label="Salva esito KO" icon="pi pi-save" style="font-size: 14px; border: 1px solid #b86b12;" :disabled="manualBusy || !data.motivazione.trim() || (data.savedEsito === 2 && data.motivazione.trim() === data.savedMotivazione)" @click="saveManualOutcome(data)" />
            </div>
            <small v-if="data.savedEsito !== 2 || data.motivazione.trim() !== data.savedMotivazione" class="block mt-2">Esito KO da salvare</small>
          </div>
        </template>
      </Column>
    </DataTable>
    <template #footer>
      <Button label="Completa file" icon="pi pi-check" style="font-size: 14px;" :disabled="!canCompleteManual" :loading="manualCompleting" @click="completeManualPractice" />
    </template>
  </Dialog>
</template>

<script>
import {ref, computed, onMounted, getCurrentInstance, nextTick } from 'vue';
import Loader from "@/components/Loader.vue"
import ConsultazioneFilePratica from './ConsultazioneFilePratica.vue';
import Service from "@/services/ask-pratiche/gestione-pratiche";
import moment from 'moment'
var CSV = require("xlsx");
import { useToast } from "primevue/usetoast";

export default {
  components: {
    Loader,
    ConsultazioneFilePratica,
  },
  
  setup () { 
    const toast = useToast();
    const loading = ref(false)
    const ammissibilitaOverlay = ref(null)
    const ammissibilitaFile = ref(null)
    const openAmmissibilita = async (event, data) => {
      const target = event.currentTarget
      if (ammissibilitaFile.value?.filename === data.filename) {
        ammissibilitaOverlay.value.toggle(event)
        return
      }
      ammissibilitaOverlay.value.hide()
      ammissibilitaFile.value = data
      await nextTick()
      ammissibilitaOverlay.value.show({ currentTarget: target }, target)
    }
    const openManualFromOverlay = () => {
      const data = ammissibilitaFile.value
      ammissibilitaOverlay.value.hide()
      if (data) openManualPractice(data)
    }
    const uploadMassiveFromOverlay = (event) => {
      const data = ammissibilitaFile.value
      ammissibilitaOverlay.value.hide()
      if (data) uploadResponse(event, data)
    }
    const manualVisible = ref(false)
    const manualLoading = ref(false)
    const manualSaving = ref(false)
    const manualCompleting = ref(false)
    const manualFilename = ref('')
    const manualRows = ref([])
    const manualSearch = ref('')
    const manualFirst = ref(0)
    const manualKoOverlay = ref(null)
    const manualBulkReason = ref('')
    const filteredManualRows = computed(() => manualRows.value.filter(row =>
      String(row.code ?? '').toLowerCase().includes(manualSearch.value.trim().toLowerCase())
    ))
    const manualOptions = [
      { label: 'Esito in attesa', value: null },
      { label: 'Esito OK', value: 1 },
      { label: 'Esito KO', value: 2 }
    ]
    const manualBusy = computed(() => manualLoading.value || manualSaving.value || manualCompleting.value)
    const canCompleteManual = computed(() => !manualBusy.value && manualRows.value.length > 0 && manualRows.value.every(row =>
      (row.esito === 1 || row.esito === 2) && row.esito === row.savedEsito &&
      (row.esito !== 2 || (row.motivazione.trim() && row.motivazione.trim() === row.savedMotivazione))
    ))
    const detailVisible = ref(false)
    const detailFilename = ref('')
    const detailType = ref('request')
    const activeTabIndex = ref(0)
    const activeTabIndexMethod = ref(0)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const filename = ref('')
    const types = ref([
      {name:'ee', description: 'Energia'},
      {name:'gas', description: 'Gas'}
    ]);
    const allowedType = {
      'csv' : 'csv'
    }

    const fileUpload = ref()
    const headingsVT4 = ["COD_SERVIZIO","COD_FLUSSO","PIVA_UTENTE","PIVA_GESTORE","CP_UTENTE","CP_GESTORE","COD_POD","VERIFICA_AMM","COD_CAUSALE","MOTIVAZIONE"]
    const headingsVTG1 = ["COD_SERVIZIO", "COD_FLUSSO", "PIVA_UTENTE", "PIVA_GESTORE", "CP_UTENTE", "CP_GESTORE", "COD_PDR", "VERIFICA_AMM", "COD_CAUSALE", "MOTIVAZIONE"]
    const headingsS1 = ["COD_SERVIZIO",	"COD_FLUSSO",	"PIVA_UTENTE",	"PIVA_GESTORE",	"CP_UTENTE",	"CP_GESTORE",	"COD_POD",	"VERIFICA_AMM",	"COD_CAUSALE",	"MOTIVAZIONE"]
    const id_pratica = ref({})

    const items = ref()
    const selectedService = ref(null)
    const fileTableContainer = ref(null)
    const fileTableHeight = ref(0)
    const selectService = code => {
      fileTableHeight.value = Math.max(fileTableHeight.value, fileTableContainer.value?.offsetHeight || 0)
      selectedService.value = code
    }
    const serviceCode = file => file.cod_servizio || file.type_file
    const serviceOptions = computed(() => [...new Set((items.value || []).map(serviceCode).filter(Boolean))].sort())
    const filteredItems = computed(() => (items.value || []).filter(file => !selectedService.value || serviceCode(file) === selectedService.value))
    const ids_richiesta = ref([])

    const submitted = ref(false)

    onMounted(() => { 
      loading.value = true
      const promises = [
        getActivePratiche()
      ]
      Promise.all(promises).finally(()=>{
        loading.value = false
      })
    })

    const getActivePratiche = async () => {
      ammissibilitaOverlay.value?.hide()
      items.value = []
      ids_richiesta.value = []
      loading.value = true

      await service.getPratiche().then((res)=>{
        res.items.forEach(pratica => {
          ids_richiesta.value.push(pratica.id_richiesta)
          pratica.type_file = pratica.filename.replace(/\d{14}\.[^.]+$/, '');
        });
        items.value = res.items.filter(el => !/^(IV|PK)/.test(el.filename))
      })
      .finally(()=>{
        loading.value = false
      })
    }

    const isManualPractice = (data) => data.gestione_manuale === true || data.gestione_manuale === 1
    const canUploadMassive = (data) => !data.data_eliminazione && data.provider === 'agf' && !!data.id_richiesta
    const massiveUploadHint = (data) => {
      if (data.provider === 'cei') return 'Ammissibilità massiva CEI non ancora disponibile'
      if (data.provider !== 'agf') return 'Provider del file di richiesta non registrato o non supportato'
      if (!data.id_richiesta) return "Associa prima l'ID della richiesta"
      return 'Carica il file di risposta AGF della richiesta'
    }
    const normalizeManualRow = (row) => ({
      ...row,
      esito: row.esito == null ? null : Number(row.esito),
      motivazione: row.motivazione || '',
      savedEsito: row.esito == null ? null : Number(row.esito),
      savedMotivazione: row.motivazione || ''
    })
    const manualError = (error) => toast.add({severity: 'error', summary: 'Esiti pratiche', detail: error.response?.data?.message || 'Operazione non riuscita', life: 10000})
    const openManualPractice = async (data) => {
      manualFilename.value = data.filename
      manualRows.value = []
      manualSearch.value = ''
      manualFirst.value = 0
      manualBulkReason.value = ''
      manualVisible.value = true
      manualLoading.value = true
      try {
        const response = await service.getManualPractice(data.filename)
        manualRows.value = response.items.map(normalizeManualRow)
      } catch (error) {
        manualVisible.value = false
        manualError(error)
      } finally {
        manualLoading.value = false
      }
    }
    const setAllManualOutcomes = async (esito, motivazione = '') => {
      if (manualBusy.value || !manualRows.value.length || ![1, 2].includes(esito)) return
      const reason = esito === 2 ? motivazione.trim() : null
      if (esito === 2 && !reason) return
      manualKoOverlay.value?.hide()
      manualSaving.value = true
      let saved = 0
      try {
        for (const row of manualRows.value) {
          const response = await service.saveManualPractice(manualFilename.value, row.id, esito, reason)
          Object.assign(row, normalizeManualRow(response.item))
          saved++
        }
        toast.add({severity: 'success', summary: 'Esiti salvati', detail: `${saved} righe salvate con esito ${esito === 1 ? 'OK' : 'KO'}`, life: 5000})
      } catch (error) {
        toast.add({severity: 'error', summary: 'Salvataggio interrotto', detail: `${saved} righe su ${manualRows.value.length} salvate. ${error.response?.data?.message || 'Operazione non riuscita. Riprovare per completare il salvataggio.'}`, life: 10000})
      } finally {
        manualSaving.value = false
      }
    }
    const saveManualOutcome = async (row) => {
      manualSaving.value = true
      try {
        const response = await service.saveManualPractice(manualFilename.value, row.id, row.esito, row.esito === 2 ? row.motivazione.trim() : null)
        Object.assign(row, normalizeManualRow(response.item))
      } catch (error) {
        row.esito = row.savedEsito
        row.motivazione = row.savedMotivazione
        manualError(error)
      } finally {
        manualSaving.value = false
      }
    }
    const changeManualOutcome = (row) => {
      if (row.esito !== 2) saveManualOutcome(row)
    }
    const completeManualPractice = async () => {
      if (!canCompleteManual.value) return
      manualCompleting.value = true
      try {
        await service.completeManualPractice(manualFilename.value)
        manualVisible.value = false
        toast.add({severity: 'success', summary: 'File completato', detail: 'Gli esiti sono stati elaborati', life: 10000})
        await getActivePratiche()
      } catch (error) {
        manualError(error)
        await getActivePratiche()
      } finally {
        manualCompleting.value = false
      }
    }

    const showFileDetails = (data, type) => {
      if (data.data_eliminazione && type !== 'history') return
      detailFilename.value = data.filename
      detailType.value = type
      detailVisible.value = true
    }
    const loadDetailData = async (filename) => {
      if (detailType.value === 'history') {
        const result = await service.getRequestDeletionHistory(filename)
        return {
          ...result,
          items: result.items.map(row => ({
            ...row,
            data: row.data && moment(row.data).isValid() ? moment(row.data).format('DD/MM/YYYY HH:mm:ss') : row.data,
          })),
        }
      }
      return detailType.value !== 'response'
        ? service.getRequestPratica(filename, detailType.value === 'delete')
        : service.getResponsePratica(filename)
    }
    const deleteRequestRows = (payload) => service.deleteRequestPratica(payload)

    const saveIdPratica = (file, id, index) => {
      loading.value = true

      if (ids_richiesta.value.includes(id)) {
        loading.value = false
        toast.add({severity:'warn', summary:'Associazione non riuscita', detail: `ID di Richiesta già utilizzato`, life: 10000});
        
        delete id_pratica.value[index]

        return
      }

      let severity = 'success'
      let summary = 'Associazione eseguita'
      let detail = `${file} è stato associato all'id ${id_pratica.value[index]}`

      service.saveIdPratica(file, id_pratica.value[index])
      .then((res)=>{
        loading.value = false
        if (!res) {
          severity = 'warn'
          summary = 'Associazione non riuscita'
          detail = `${file} non è stato associato all'id ${id_pratica.value[index]}`
        }
        toast.add({severity:severity, summary:summary, detail: detail, life: 10000});
      })
      .finally(()=>{
        delete id_pratica.value[index]
        getActivePratiche()
      })
    }

    const uploadResponse = async (event, data) => {
      if (!canUploadMassive(data)) return
      const { id_richiesta: id, type_file, provider } = data
      submitted.value = true
      let filename = event.files[0].name.replace('risposte_','')
      let id_file = filename.replace('.csv','')

      if (id_file == id) {
        fileUpload.value = event.files[0]
        if (await validateFile(fileUpload.value, type_file)) {
          loading.value = true
          service.uploadFilePratica(fileUpload.value, id, type_file, provider)
          .then((res) => {
            if (res) {
              toast.add({severity:'success', summary:'Importazione eseguita', detail: `Elaborazione del file di risposta eseguita correttamente`, life: 10000});
            } else {
              toast.add({severity:'warn', summary:'Importazione fallita', detail: `Elaborazione del file di risposta non riuscita`, life: 10000});
            }
            fileUpload.value = null
          })
          .catch((error) => {
            toast.add({severity:'error', summary:'Importazione fallita', detail: error.response?.data?.message || 'Elaborazione del file di risposta non riuscita', life: 10000})
          })
          .finally(() => {
            getActivePratiche()
            loading.value = false
          })
        }
      }else{
        toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non corrisponde alla richiesta selezionata`, life: 10000});
      }
    }

    const downloadFilePratica = (file) => service.downloadFileName(file)
    
    const validateFile = async (file, type_file)  => {
      let type_headings
      switch (type_file) {
        case 'VT4':
        case 'VT1':
          type_headings = headingsVT4
          break;
        case 'VTG4':
        case 'VTG1':
        case 'SG1':
          type_headings = headingsVTG1
          break;
        case 'S1':
          type_headings = headingsS1
          break;
        default:
          break;
      }
      const data = await file.arrayBuffer();
      const workbook = CSV.read(data);
      let first_sheet_name = workbook.SheetNames[0];
      let ws = workbook.Sheets[first_sheet_name];
      const headers = (CSV.utils.sheet_to_json(ws, { header: 1 }))[0];

      const isSameHeaders = JSON.stringify(headers) === JSON.stringify(type_headings);

      if (!isSameHeaders) {
        toast.add({severity:'warn', summary:'Importazione fallita', detail: `Il file di risposta inserito non è conforme con la richiesta selezionata`});
        
        return false
      }else{
        return true
      }
    }

    return {
      ammissibilitaOverlay,
      ammissibilitaFile,
      openAmmissibilita,
      openManualFromOverlay,
      uploadMassiveFromOverlay,
      isManualPractice,
      canUploadMassive,
      massiveUploadHint,
      manualVisible,
      manualLoading,
      manualCompleting,
      manualBusy,
      manualFilename,
      manualRows,
      manualSearch,
      manualFirst,
      manualKoOverlay,
      manualBulkReason,
      filteredManualRows,
      setAllManualOutcomes,
      manualOptions,
      canCompleteManual,
      openManualPractice,
      changeManualOutcome,
      saveManualOutcome,
      completeManualPractice,
      detailVisible,
      detailFilename,
      detailType,
      showFileDetails,
      loadDetailData,
      deleteRequestRows,
      loading,
      activeTabIndex,
      activeTabIndexMethod,
      allowedType,
      uploadResponse,
      downloadFilePratica,
      types,
      filename,
      id_pratica,
      saveIdPratica,
      getActivePratiche,
      items,
      selectedService,
      fileTableContainer,
      fileTableHeight,
      selectService,
      serviceOptions,
      filteredItems,
      moment,
    }
  },
}
</script>

<style scoped>
:deep(.file-eliminato > td) {
  background: var(--surface-100) !important;
  color: var(--text-color-secondary);
}
.manual-outcomes :deep(.p-button) {
  font-size: 14px;
}
.manual-ko-editor {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.manual-ko-editor :deep(textarea) {
  flex: 1 1 auto;
  min-width: 10rem;
  width: 100%;
}
.manual-ko-editor :deep(.p-button) {
  flex-shrink: 0;
  white-space: nowrap;
}
.file-row-buttons {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.5rem;
}
.file-row-buttons :deep(.p-button) {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  flex-shrink: 0;
  font-size: 14px;
}
.ammissibilita-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 14px;
}
.ammissibilita-filename {
  font-size: 12px;
  overflow-wrap: anywhere;
  color: var(--text-color-secondary);
}
.ammissibilita-actions :deep(.p-button) {
  width: 100%;
  min-height: 2.5rem;
  font-size: 14px;
  justify-content: center;
}
.ammissibilita-actions :deep(.p-fileupload) {
  width: 100%;
}
.p-card{
  min-width: 335px !important;
}
.btn-red, .btn-red:hover{
  color: #ffffff;
  background: #d32f2f;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 3px;
  border: 1px solid #2196F3;
}
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 250px;
  border: 2px dashed rgba(156, 156, 156, 0.577);
  border-radius: 5px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 250px;
  background: #ffffff;
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  box-shadow: none;
}

.form-file .remove-file {
    color: red;
    margin-top:15px;
    cursor: pointer;
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
}

.form-file .button-wrapper span.label.active {
  color: #2196F3;
}

#uploadIV, #uploadPK {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
.btn-download{
  width: 173px;
}
</style>
